import React from 'react'

export const Input = React.forwardRef(({ label, showLabel = true, className = '', ...props }, ref) => (
  <div className="flex flex-col">
    {label && showLabel && (
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
    )}
    <div className="relative">
      <input
        ref={ref}
        className={`w-full px-4 py-3 bg-white rounded-xl shadow-[0_2px_8px_rgb(0,0,0,0.08)] focus:shadow-[0_2px_8px_rgb(0,0,0,0.12)] focus:ring-0 focus:outline-none text-gray-900 placeholder-gray-400 text-sm ${className}`}
        {...props}
      />
      {props.type === 'search' && (
        <div className="absolute inset-y-0 right-0 flex items-center pr-3">
          <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
      )}
    </div>
  </div>
))

Input.displayName = 'Input'

export default Input 